import React from "react";
import { useEffect } from "react";
import "../assets/Common.scss";
import "../assets/fonts/font.css";
import reloadForChecksum from "../util/ReloadChecksum";
import chipsApi from "../js/chips-api";
import {
  moveToLogin,
  trackEvent,
  openWebView,
  calc,
  getChipsUid,
  showBottomSheet,
} from "../js/chips-common.js";

export default function Guerrilla(props) {
  const dev = props.dev;
  const domain = dev
    ? `https://api.${dev}.chips.today`
    : "https://api.chips.today";

  const notificationIdentifier = "topic_offerwall_benefit";
  const [notificationStatus, setNotificationStatus] = React.useState(false);
  const [guerrillaList, setGuerrillaList] = React.useState([]);
  const [guerrillaListTitle, setGuerrillaListTitle] =
    React.useState("곧 2배 적립이 시작해요");

  const [guerrillaIsLiving, setGuerrillaIsLiving] = React.useState(false);

  const toggleOnImage =
    "https://cdn.chips.today/logic/images/2024/07/01/1719831169778-296655ae-1eac-4505-ae5d-8c367c1c0a74.png";
  const toglleOffImage =
    "https://cdn.chips.today/logic/images/2024/07/01/1719831197151-296d8c04-a731-4682-bf0f-95523f094a03.png";

  useEffect(() => {
    try {
      window.moveToLogin = moveToLogin;

      document.removeEventListener("visibilitychange", visibilityChange);
      document.addEventListener("visibilitychange", visibilityChange);

      // eslint-disable-next-line no-undef
      chipsApp.setThemeColor("#FFFFFF");

      // eslint-disable-next-line no-undef
      chipsApp.setFullscreen(false);

      // eslint-disable-next-line no-undef
      chipsApp.showHeader(true);
    } catch (e) {}

    // eslint-disable-next-line no-undef
    refresh();
    reloadForChecksum();
  }, []);
  const visibilityChange = () => {
    if (!document.hidden) {
      // 페이지가 트랜지션 과정에서 active 상태로 잡히는 경우가 있어서
      // 500ms 이후 페이지가 active 상태인 경우에만 새로고침 함
      setTimeout(() => {
        if (!document.hidden) {
          refresh();
        }
      }, 500);
      refresh();
    }
  };
  document.addEventListener("visibilitychange", visibilityChange);
  useEffect(() => {
    const title =
      guerrillaList.length > 0 ? "2배 적립 Live" : "곧 2배 적립이 시작해요";
    setGuerrillaListTitle(title);
  }, [guerrillaList]);

  function refresh() {
    try {
      if (!getChipsUid()) {
        setGuerrillaList([]);
        return;
      }
      getGuerrillaList();
      getNotificationStatus();
    } catch (e) {}
  }
  function showLoginBottomSheet() {
    trackEvent("login_required");

    const attributes = {
      icon: "https://cdn.chips.today/logic/images/2023/12/29/1703834493636-4f7b84a7-7ef3-44e5-b02d-e91f6e0d315f.png",
      title: "로그인/회원가입을 해주세요!",
      body: "신규 이벤트 바로 참여하면 3일 후 랜덤 상품 당첨!<br>이벤트에 참여하려면<br>로그인 또는 회원가입을 해주세요.",
      secondary_button_text: "취소",
      primary_button_text: "시작하기",
      primary_button_callback: "moveToLogin()",
    };

    try {
      // eslint-disable-next-line no-undef
      chipsApp.showLoginBottomSheet(JSON.stringify(attributes));
    } catch (e) {}
  }
  function getGuerrillaList() {
    try {
      if (!getChipsUid()) {
        setGuerrillaList([]);
        return;
      }
      // eslint-disable-next-line no-undef
      chipsApi.request({
        method: "get",
        url: `${domain}/api/v1/offerwall/benefits`,
        then: (response) => {
          const data = response.data;
          setGuerrillaList(data);
          setGuerrillaIsLiving(data.length > 0);
        },
      });
    } catch (e) {}
  }

  function getNotificationStatus() {
    try {
      if (!getChipsUid()) {
        setNotificationStatus(false);
        return;
      }
      // eslint-disable-next-line no-undef
      chipsApi.request({
        method: "get",
        url: `${domain}/api/v1/push_notifications`,
        then: (response) => {
          const data = response.data;
          data.forEach((notification) => {
            if (notification.topic === notificationIdentifier) {
              setNotificationStatus(notification.enabled);
            }
          });
        },
      });
    } catch (e) {}
  }

  function changeNotificationForGuerrilla(enabled) {
    try {
      if (!getChipsUid()) {
        showLoginBottomSheet();
        return;
      }
      trackEvent("set_notification", {
        enabled: enabled === true ? true : false,
        topic: notificationIdentifier,
      });
      // eslint-disable-next-line no-undef
      chipsApi.request({
        method: "post",
        url: `${domain}/api/v1/push_notifications`,
        data: [
          {
            topic: notificationIdentifier,
            enabled: enabled,
          },
        ],
        then: (response) => {
          const data = response.data;
          getNotificationStatus();
          if (enabled) {
            showBottomSheet({
              title: "알림 설정이 완료되었어요",
              body: `2배 적립이 시작하면<br/>알림으로 빠르게 알려드릴게요`,
              secondary_button_text: "닫기",
              secondary_button_style: "primary",
            });
          }
        },
      });
    } catch (e) {}
  }

  return (
    <div
      style={{
        background: "#FFF",
        width: "100vw",
        height: "100vw",
        overflowY: "scroll",
        overflowX: "hidden",
      }}
    >
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"
      />
      <div
        style={{
          background: "#FFF",
          position: "fixed",
          top: 0,
          left: 0,
          bottom: 0,
          width: "100vw",
          zIndex: 0,
          overflowY: "scroll",
          overflowX: "hidden",
          // marginBottom: calc(120),
        }}
      >
        <div
          style={{
            position: "relative",
            width: "100vw",
            height: calc(48),
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              fontFamily: "Spoqa Han Sans Neo",
              fontSize: calc(14),
              fontWeight: 400,
              lineHeight: calc(20),
              display: "flex",
              padding: `0 ${calc(0)} ${calc(0)} ${calc(20)}`,
              color: notificationStatus ? "#9E9E9E" : "#212121",
            }}
          >
            {notificationStatus
              ? "2배 적립 알림을 받고 있어요"
              : "2배 적립을 놓치지 않도록 알림을 보내드릴까요?"}
          </div>

          <div
            style={{
              display: "flex",
              paddingRight: calc(20),
            }}
          >
            <img
              src={notificationStatus ? toggleOnImage : toglleOffImage}
              style={{
                width: calc(40),
                height: calc(24),
                objectFit: "cover",
              }}
              className="active-only-alpha"
              onClick={() => {
                changeNotificationForGuerrilla(!notificationStatus);
              }}
            />
          </div>
        </div>
        <div
          style={{
            width: "100vw",
          }}
        >
          <img
            src="https://cdn.chips.today/logic/images/2024/07/01/1719806249314-8a866132-7889-45ef-a57e-6536b7b4e06f.png"
            style={{
              width: "100vw",
              height: calc(140),
              objectFit: "cover",
            }}
          />
        </div>

        <div
          style={{
            position: "relative",
            overflow: "hidden",
            height: calc(64),
            width: "100vw",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div
            style={{
              fontFamily: "Spoqa Han Sans Neo",
              fontSize: calc(18),
              fontWeight: 700,
              lineHeight: calc(24),
              display: "flex",
              paddingLeft: calc(20),
            }}
          >
            {guerrillaListTitle}
          </div>
          {guerrillaIsLiving && (
            <div style={{ paddingLeft: calc(3) }}>
              <img
                style={{
                  width: calc(6),
                  height: calc(6),
                  objectFit: "cover",
                }}
                src="https://cdn.chips.today/logic/barcode/zips/2024/07/01/1719830893884-d537eb6d-b0b0-4652-8257-bc0fd2a2e935.svg"
              />
            </div>
          )}
        </div>
        {guerrillaList.length !== 0 && guerrillaList.forEach((guerrilla) => {})}
        {!guerrillaIsLiving && (
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "#F5F5F5",
                borderRadius: calc(10),
                width: calc(320),
              }}
            >
              <img
                style={{
                  paddingTop: calc(48),
                  paddingBottom: notificationStatus ? calc(48) : 0,
                  width: calc(186),
                  objectFit: "cover",
                }}
                src="https://cdn.chips.today/logic/images/2024/07/01/1719841534567-f3edab93-5989-425e-815d-a2ab10592de2.png"
              />
              {!notificationStatus && (
                <div
                  style={{
                    paddingTop: calc(16),
                    paddingBottom: calc(48),
                  }}
                >
                  <div
                    className={"active-large"}
                    style={{
                      backgroundColor: "#7CFC00",
                      borderRadius: calc(6),
                      textAlign: "center",
                      justifyContent: "center",
                      width: calc(127),
                      height: calc(40),
                      fontFamily: "Spoqa Han Sans Neo",
                      fontSize: calc(16),
                      color: "#212121",
                    }}
                    onClick={() => {
                      if (!notificationStatus) {
                        changeNotificationForGuerrilla(true);
                      }
                    }}
                  >
                    알림 설정 하기
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        <div
          style={{
            top: calc(0),
            width: "100vw",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "start",
          }}
        >
          {guerrillaList.length > 0 &&
            guerrillaList.map((guerrilla) => (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  height: calc(72),
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    paddingLeft: calc(20),
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={
                      guerrilla["image_url"] ||
                      "https://cdn-dev.chips.today/logic/images/2024/07/04/1720066684495-ff1da4ab-1471-4594-a77a-82528021633c.png"
                    }
                    style={{
                      // corner radius to circle
                      borderRadius: calc(24),
                      width: calc(48),
                      height: calc(48),
                    }}
                  />
                </div>
                <div
                  style={{
                    paddingLeft: calc(20),
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      height: calc(18),
                      fontSize: calc(12),
                      color: "#9E9E9E",
                    }}
                  >
                    {guerrilla["ad_name"] || "ad_name"}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      fontSize: calc(16),
                      color: "#212121",
                      fontFamily: "Spoqa Han Sans Neo",
                      fontWeight: "bold",
                      height: calc(24),
                    }}
                  >
                    {guerrilla["title"] || "title"}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      height: calc(30),
                      justifyContent: "center",
                      alignItems: "center",
                      gap: calc(2),
                    }}
                  >
                    {guerrilla["description"] && (
                      <div
                        style={{
                          display: "flex",
                          borderRadius: calc(12),
                          backgroundColor: "#FFECEC",
                          height: calc(24),
                          padding: `${calc(0)} ${calc(8)}`,
                          justifyContent: "center",
                          cornerRadius: calc(6),
                          fontFamily: "Spoqa Han Sans Neo",
                          fontWeight: "bold",
                          fontSize: calc(12),
                          color: "#F33A6A",
                        }}
                      >
                        {guerrilla["description"] || "description"}
                      </div>
                    )}
                    {(guerrilla["user_participation_limit"] || 0) > 0 && (
                      <div
                        style={{
                          display: "flex",
                          borderRadius: calc(12),
                          backgroundColor: "#F0F9FF",
                          height: calc(24),
                          padding: `${calc(0)} ${calc(8)}`,
                          justifyContent: "center",
                          cornerRadius: calc(6),
                          fontFamily: "Spoqa Han Sans Neo",
                          fontWeight: "bold",
                          fontSize: calc(12),
                          color: "#0096FF",
                        }}
                      >{`선착순 ${
                        guerrilla["user_participation_limit"] || 0
                      }명`}</div>
                    )}
                  </div>
                </div>
                <div
                  style={{
                    paddingRight: calc(20),
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    className={"active-large"}
                    style={{
                      padding: `${calc(0)} ${calc(8)}`,
                      backgroundColor: guerrilla["participated"]
                        ? "#E9FFCC"
                        : "#7CFC00",
                      borderRadius: calc(6),
                      textAlign: "center",
                      justifyContent: "center",
                      width: calc(60),
                      height: calc(34),
                      font: "Spoqa Han Sans Neo",
                      fontSize: calc(12),
                      color: guerrilla["participated"] ? "#BDBDBD" : "#212121",
                    }}
                    onClick={() => {
                      if (!guerrilla["participated"]) {
                        trackEvent("adison", {
                          id: `${guerrilla.campaign_id}`,
                        });
                        try {
                          const url = `chips://adison_offerwall/${guerrilla.campaign_id}?keep_parent=false`;
                          window.location.href = url;
                        } catch (e) {}
                      }
                    }}
                  >
                    {guerrilla["participated"] ? "받기 완료" : "포인트 받기"}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
